// extracted by mini-css-extract-plugin
export default {"label":"MultipleChoiceQuestion_label__gjaW8","disabled":"MultipleChoiceQuestion_disabled__PGKcF"};